<style lang="stylus">
    .files-item-list
        width: 100%;
        height: 52px;
        padding-right: 40px;
        text-align: center;
        font-size: 14px;
        cursor: pointer;
        position: relative;
        user-select: none;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        border-radius 6px
        &:hover
            background linear-gradient(90deg, rgba(0, 0, 0, 0.03) 0%, rgba(0, 0, 0, 0) 100%);
            .file-context
                visibility visible
            .list-star
                .list-star-block
                    display flex
            .filesitem-tag
                display flex
            .filesitem-select-list
                display flex
            .file-customtag
                .file-customtag-arrow,p
                    display block
        .file-name
            padding-left 24px
            pointer-events none
            width: 50%;
            display flex
            align-items center
            &.files-name,&.team-name
                width 40%
            .file-context
                pointer-events auto
                visibility hidden
                width 24px
                height 24px
                line-height 24px
                flex-shrink 0
                use
                    pointer-events none
            .show-context
                visibility visible
            .file-cut-icon
                opacity: 0.5
            .file-icon
                pointer-events auto
                margin: 0;
                width: 24px;
                height: 30px;
                flex-shrink 0
                use
                    pointer-events none
            span
                max-width: 666px;
                height: 100%;
                margin-right: auto;
                background: transparent;
                overflow: hidden;
                text-overflow: ellipsis;
                padding-left: 12px;
                box-sizing: border-box;
                border: none;
                outline: none;
                cursor: pointer;
                user-select: none;
                pointer-events: auto;
                white-space: nowrap;
                text-overflow: ellipsis;
            .list-viewonly
                display flex
                justify-content center
                align-items center
                flex-shrink 0
                border 1px solid rgba(0, 15, 38, 0.2)
                border-radius 5px
                padding 4px 8px
                width 80px
                margin-right 6px
                p
                    white-space nowrap
                    text-overflow ellipsis
                    overflow hidden
                    font-size 12px
                    color #222
            .list-viewonly-block
                width 80px
                height 100%
                margin-right 6px
                flex-shrink 0
            .list-star
                display flex
                justify-content center
                align-items center
                width 22px
                height 22px
                margin-right 10px
                pointer-events auto
                flex-shrink 0
                &.active
                    .list-star-block
                        display flex
                .list-star-block
                    display none
                svg
                    width 16px
                    height 16px
                    stroke #c4c4c4
                    fill none
                    &:not(.active):hover
                        stroke #c4c4c4
                        fill #c4c4c4
                    &.active:hover
                        stroke #FFC42C
                        fill #FFC42C
                    &.active
                        stroke #FFD056
                        fill #FFD056

        .file-rename{
            height: 100%;
            background: transparent;
            color: #000;
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 0 5px;
            box-sizing: border-box;
            border: none;
            outline: none;
            display: flex;
            align-items: center;
            width: 100%;
        }
        .file-time
            white-space nowrap
            text-overflow ellipsis
            overflow hidden
            font-size 13px
            text-indent 15px;
            width 30%
            text-align left
            &.shareToMe-time
                width 20%
            &.files-time
                width 20%
        .file-creator
            pointer-events none
            font-size 13px
            width 20%
            text-align left
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
            padding-right 20px
        .file-permission
            pointer-events none
            font-size 13px
            width 10%
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
            text-align left
        .file-size
            pointer-events none
            white-space nowrap
            font-size 13px
            width 20%
            text-align left
            text-indent 15px
        .file-notes
            white-space nowrap
            font-size 13px
            width 20%
            text-align left
            text-indent 15px
            textOverflow()
        .file-customtag
            display flex
            align-items center
            pointer-events none
            white-space nowrap
            font-size 13px
            width 20%
            height 100%
            text-align left
            text-indent 15px
            pointer-events auto
            &.keep-expand
                p
                    display block
            p
                display none
                max-width calc(100% - 10px)
                overflow hidden
                text-overflow ellipsis
                white-space nowrap

            .file-customtag-arrow
                display none
                margin-left 2px
                width 8px
                height 8px
        .file-pv
            text-indent 45px
        .file-time-team
            width 30%
        .file-creator-team
            width 20%
        .file-size-team
            width 10%
        .file-time-recycle
            width 15%
        .file-size-recycle
            width 15%

    .publish-box
    	position absolute
    	left 38px
    	top 6px
    	display flex
    	justify-content space-around
    	align-items center
    	width 18px
    	height 18px
    	border-radius 50%
    	border 1px solid #f90
    	background #fff
    	.publish-icon
    		display block
    		width 10px
    		height 10px
    		fill #f90
    	&.active
    		border-color #017fff
    		.publish-icon
    			fill #017fff

    .filesitem-select-list
        position absolute
        left 2px
        top 14px
        display none
        align-items center
        justify-content center
        width 24px
        height 24px
        cursor pointer

        &.selected
            display flex

        .select-icon
            display inline-block
            width 16px
            height 16px
            background-color #fff
            border-radius 100%
            border 1px solid #ccc
            &:hover
                border 1px solid #017FFF
</style>

<template>
    <div
        class="files-item-list"
        :class="{ 'list-item-active': fileSelected.includes(index) }"
        :data-index="index"
        :key="index"
        @contextmenu.prevent.stop="
            contextmenu($event, file, index);
            contextmenuEvent();
        "
        @click.exact="listFileClickEvent(index, file)"
        @click.ctrl.exact="ctrlSelect(index)"
    >
        <!-- @dblclick="!mulSelectMode && openFiles(file)"> -->
        <div
            v-if="['files', 'openRecord', 'recycle'].includes(type) && !pcSaveInput"
            class="filesitem-select-list"
            :class="{ selected: fileSelected.includes(index) }"
            @mousedown.stop=""
            @click.stop="selectEvent(index)"
        >
            <i v-show="!fileSelected.includes(index)" class="select-icon"></i>
            <img v-show="fileSelected.includes(index)" :src="require('@/home/assets/img/files/select-active.svg')" alt="" />
        </div>

        <div class="file-name" :class="{ 'files-name': type == 'files', 'team-name': type == 'team' }">
            <div v-if="filePublish" class="publish-box" :class="{ active: filePublish == 'pass' }">
                <iconSymbol class="publish-icon" name="publish-fill" :title="filePublish == 'pass' ? $t('passPublish') : $t('pendingPublish')" />
            </div>
            <img
                class="file-icon"
                :class="{
                    'file-cut-icon': file.info && $parent.operateType == 'cut' && $parent.operateIds.includes(file.info.id),
                }"
                name="eddxFileIcon"
                @mouseenter="mouseover($event, file)"
                @mouseleave="mouseout"
                src="@/home/assets/img/files/file.svg"
                alt=""
            />
            <!-- <iconSymbol class='file-icon' :class="{'file-cut-icon':  file.info && $parent.operateType=='cut' &&  $parent.operateIds.includes(file.info.id)}" name="eddxFileIcon" @mouseenter.native="mouseover($event, file)" @mouseleave.native="mouseout" /> -->
            <!-- <input type="text" class="file-rename" v-model="renameValue" v-if="renameShow == index" @blur="blur()"> -->
            <span :title="fileName">{{ fileName }}</span>
            <template v-if="isPC">
                <div class="list-viewonly" v-if="(!vip && file.info && file.info.edit) || (file.edit && !['recycle', 'team'].includes(type))">
                    <p :title="$t('editor')">{{ $t("editor") }}</p>
                </div>
            </template>
            <template v-else>
                <div
                    class="list-viewonly"
                    v-if="(file.info && file.info.edit === false) || (file.edit === false && !['recycle', 'team'].includes(type))"
                >
                    <p :title="$t('read')">{{ $t("read") }}</p>
                </div>
            </template>
            <div class="list-viewonly-block" v-else></div>
            <div
                class="list-star"
                v-if="file.info && ['files', 'openRecord', 'star'].includes(type)"
                :class="{ active: file.info.start_tag && file.info.start_tag != 0 }"
                @dblclick.stop=""
            >
                <div class="list-star-block" @click.stop="setStarFile(file)">
                    <iconSymbol :class="{ active: file.info.start_tag == 1 }" name="filesitem-star" />
                </div>
            </div>
            <!-- <iconSymbol class='file-context' v-if='type !== "team" && !mulSelectMode && !pcSaveInput' @dblclick.stop="" :class="{'show-context': fileSelected.length ==1 && fileSelected.includes(index)}"  @click.prevent.native="contextmenu($event, file, index)" name="moreFileIcon"/> -->
            <!-- <div class='file-context' v-if='fileSelected && fileSelected.length >1 && fileSelected.includes(index) && type !== "team"' @dblclick.stop="" v-text='fileSelected && fileSelected.length'></div> -->
        </div>

        <template v-if="type == 'openRecord'">
            <Time
                class="file-time"
                :time="new Date(fileTime)"
                :type="new Date().getTime() - new Date(fileTime).getTime() < 259200000 ? 'relative' : 'datetime'"
            />
            <div class="file-size">{{ renderSize(file.size) }}</div>
        </template>

        <template v-else-if="type == 'share'">
            <div class="file-time" :title="new Date(fileTime).toLocaleString()">{{ new Date(fileTime).toLocaleString() }}</div>
            <div class="file-size file-pv">{{ file.pv }}</div>
        </template>

        <template v-else-if="type == 'shareToMe'">
            <div class="file-time shareToMe-time" :title="new Date(fileTime).toLocaleString()">{{ new Date(fileTime).toLocaleString() }}</div>
            <div class="file-creator" :title="file.creator">{{ file.creator }}</div>
            <div class="file-permission" :title="getPermission(file.permission)">{{ getPermission(file.permission) }}</div>
        </template>

        <template v-else-if="type == 'publishFile'">
            <div class="file-time" :title="new Date(fileTime).toLocaleString()">{{ new Date(fileTime).toLocaleString() }}</div>
            <div class="file-size file-pv">{{ file.used }}</div>
        </template>

        <template v-else-if="type == 'team'">
            <div class="file-time file-time-team">{{ new Date(fileTime).toLocaleString() }}</div>
            <div class="file-creator file-creator-team" :title="file.info.creator && file.info.creator.nick_name">
                {{ file.info.creator && file.info.creator.nick_name }}
            </div>
            <div class="file-size file-size-team">{{ renderSize(file.size) }}</div>
        </template>

        <template v-else-if="type == 'files'">
            <div class="file-time files-time" :title="new Date(fileTime).toLocaleString()">{{ new Date(fileTime).toLocaleString() }}</div>
            <div
                class="file-customtag"
                :class="{ 'keep-expand': fileTagStr(file.info.custom_tag) != $t('tag') }"
                @click.prevent.stop="clickTagStr($event, index)"
                :title="fileTagStr(file.info.custom_tag)"
            >
                <p>{{ fileTagStr(file.info.custom_tag) }}</p>
                <iconSymbol class="file-customtag-arrow" name="filesitem-arrow" />
            </div>
            <div class="file-size">{{ renderSize(file.size) }}</div>
        </template>

        <template v-else-if="type == 'recycle'">
            <div class="file-time file-time-recycle" :title="new Date(fileTime).toLocaleString()">{{ new Date(fileTime).toLocaleString() }}</div>
            <div class="file-size file-time-recycle">{{ renderSize(file.size) }}</div>
            <div class="file-notes" :title="$t('expireDate', { date: file.remain_time })">{{ $t("expireDate", { date: file.remain_time }) }}</div>
        </template>

        <template v-else>
            <div class="file-time" :title="new Date(fileTime).toLocaleString()">{{ new Date(fileTime).toLocaleString() }}</div>
            <div class="file-size">{{ renderSize(file.size) }}</div>
        </template>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
    import fileItem from "./fileItem";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({})
    export default class listFile extends Mixins(fileItem) {
        @Prop() mulSelectMode: boolean;

        // 初始数据可以直接声明为实例的属性

        fileTagStr(tag) {
            // 根据custom_tag返回对应文案
            let list = {
                edraw_0: "tag",
                edraw_1: "waitdone",
                edraw_2: "done",
                edraw_3: "waitchange",
            };
            let str = tag ? this.$t(list[tag]) : this.$t(list["edraw_0"]);
            return str || tag;
        }
        setThumbState(type, data) {
            this.$store.commit("setThumbState", {
                type,
                data,
            });
        }

        renderSize(size) {
            let s = size / 1024 / 1024;
            if (s > 1) {
                return s.toFixed(2) + "M";
            } else {
                return (size / 1024).toFixed(0) + "KB";
            }
        }
        mouseover(e, item) {
            let src = this.fileImg;
            let header;

            if (this.isPC) {
                header = 0;
            } else {
                header = document.querySelector(".user-Topbar").clientHeight;
            }

            this.setThumbState("src", src);
            this.setThumbState("top", e.pageY);
            this.setThumbState("left", e.pageX + 24);
            // this.thumbnail.src = src
            // this.thumbnail.top = e.pageY
            // this.thumbnail.left = e.pageX + 30

            if (window.innerHeight - e.pageY < 200) {
                this.setThumbState("top", this.thumbnail.top - 140);
                // this.thumbnail.top -= 140
            }
            if (window.innerWidth - e.pageX < 200) {
                this.setThumbState("left", this.thumbnail.left - 117);
                // this.thumbnail.left -= 117
            }

            this.thumbnailTimer = setTimeout(() => {
                clearTimeout(this.thumbnailTimer);
                this.setThumbState("state", true);
            }, 300);
        }

        mouseout() {
            clearTimeout(this.thumbnailTimer);
            this.setThumbState("state", false);
        }

        getPermission(index) {
            return [this.$t("read"), this.$t("editor"), this.$t("share")][index];
        }

        listFileClickEvent(index, file = null) {
            if (this.pcSaveInput) {
                this.$emit("changeSaveInputName", this.fileName);
                return; // 屏蔽pc保存文件状态
            }
            if (this.mulSelectMode) {
                this.selectFiles(index);
                this.fileSelected.length == 0 && this.$emit("cancelMulSelectMode");
            } else {
                this.openFiles(file);
            }
        }
        ctrlSelect(index) {
            if (this.pcSaveInput) return; // 屏蔽pc保存文件状态
            this.selectFiles(index);
            this.fileSelected.length == 0 && this.$emit("cancelMulSelectMode");
            this.fileSelected.length > 1 && !this.mulSelectMode && this.$emit("enterMulSelectMode");
        }
        selectEvent(index) {
            this.$emit("closeContextmenu");
            if (this.pcSaveInput) return; // 屏蔽pc保存文件状态
            if (!this.mulSelectMode && this.fileSelected[0] == index) {
                // 其他操作下可能有选择单个文件的情景出现
                this.selectFiles(index);
            } else if (!this.mulSelectMode) {
                this.selectFile(index);
                this.$emit("enterMulSelectMode");
            } else {
                this.selectFiles(index);
                this.fileSelected.length == 0 && this.$emit("cancelMulSelectMode");
            }
        }
        contextmenuEvent() {
            this.$emit("contextmenuEvent");
        }
        setStarFile(file) {
            this.$emit("setStarFile", file);
        }
        clickTagStr(e, index) {
            this.selectFile(index);
            this.$emit("clickTagStr", e);
        }
        //生命周期
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "passPublish": "已公开",
    "pendingPublish": "发布中",
    "read": "仅预览",
    "editor": "可编辑",
    "share": "可查看编辑分享",
    "teamEditWarn": "正在编辑该文件",
    "tag": "标签",
    "none": "无",
    "waitdone": "未完成",
    "done": "已完成",
    "waitchange": "需修改",
    "expireDate": "{date}天后永久删除"
  },
  "en": {
    "passPublish": "Public",
    "pendingPublish": "Announcing",
    "read": "View only",
    "editor": "Editable",
    "share": "Can view and edit sharing",
    "teamEditWarn": "Editing this file",
    "tag": "Tag",
    "none": "No",
    "waitdone": "In Process",
    "done": "Completed",
    "waitchange": "Need to be modified",
    "expireDate": "Permanently deleted after {date} days"
  },
  "fr": {
    "passPublish": "Publique",
    "pendingPublish": "Annoncer",
    "read": "Voir seulement",
    "editor": "Modifiable",
    "share": "Peut afficher et modifier le partage",
    "teamEditWarn": "Modifier ce fichier",
    "tag": "étiqueter",
    "none": "Rien",
    "waitdone": "Inachevé",
    "done": "Complété",
    "waitchange": "Besoin d'être modifié"
  },
  "de": {
    "passPublish": "Öffentlichkeit",
    "pendingPublish": "ankündigen",
    "read": "Nur anschauen",
    "editor": "Editierbar",
    "share": "Kann die Freigabe anzeigen und bearbeiten",
    "teamEditWarn": "Dieser Datei wird bearbeitet",
    "tag": "Etikette",
    "none": "Nichts",
    "waitdone": "Unfertigt",
    "done": "Gefertigt",
    "waitchange": "Bearbeitbar"
  },
  "jp": {
    "passPublish": "公開済み",
    "pendingPublish": "公開中",
    "read": "閲覧のみ",
    "editor": "編集可能",
    "share": "共有を表示および編集できます",
    "teamEditWarn": "ファイルを編集しています。",
    "tag": "ラベル",
    "none": "なし",
    "waitdone": "未完成",
    "done": "完了",
    "waitchange": "修正予定"
  },
  "es": {
    "passPublish": "Público",
    "pendingPublish": "Anunciando",
    "read": "Sólo vista",
    "editor": "Editable",
    "share": "Puede ver y editar compartir",
    "teamEditWarn": "Editando este archivo",
    "tag": "etiqueta",
    "none": "Nada",
    "waitdone": "Deshecho",
    "done": "Hecho",
    "waitchange": "Es necesario modificar"
  },
  "pt": {
    "passPublish": "Público",
    "pendingPublish": "Anunciando",
    "read": "Apenas ver",
    "editor": "Editável",
    "share": "Pode ver e editar o compartilhamento",
    "teamEditWarn": "Editando este arquivo",
    "tag": "rótulo",
    "none": "nada",
    "waitdone": "incompleto",
    "done": "Concluído",
    "waitchange": "Precisa ser modificado"
  },
  "it": {
    "passPublish": "Pubblico",
    "pendingPublish": "Annunciando",
    "read": "Visualizzare solamente",
    "editor": "Modificabile",
    "share": "Può visualizzare e modificare la condivisione",
    "teamEditWarn": "Modifica questo file",
    "tag": "etichetta",
    "none": "Niente",
    "waitdone": "Incompiuto",
    "done": "Completato",
    "waitchange": "Bisogna modificare"
  },
  "tw": {
    "passPublish": "已公開",
    "pendingPublish": "發佈中",
    "read": "僅查看",
    "editor": "可編輯",
    "share": "可查看編輯分享",
    "teamEditWarn": "正在編輯該檔案",
    "tag": "標籤",
    "none": "无",
    "waitdone": "未完成",
    "done": "已完成",
    "waitchange": "需修改"
  },
  "kr": {
    "passPublish": "공개 파일",
    "pendingPublish": "게시 중",
    "read": "보기만 가능",
    "editor": "편집 가능",
    "share": "보기,편집,공유 모두 가능",
    "teamEditWarn": "파일 편집 중",
    "tag": "태그",
    "none": "없음",
    "waitdone": "미완성",
    "done": "완료",
    "waitchange": "수정 필요"
  },
  "id": {
    "passPublish": "Publik",
    "pendingPublish": "Mengumumkan",
    "read": "Hanya lihat",
    "editor": "Edit",
    "share": "Dapat melihat dan mengedit pemakaian bersama",
    "teamEditWarn": "Mengedit file ini",
    "tag": "Tag",
    "none": "Tidak",
    "waitdone": "Sedang Diproses",
    "done": "Selesai",
    "waitchange": "Perlu dimodifikasi"
  }
}
</i18n>
